    document.addEventListener("DOMContentLoaded", function () {
        const rows = document.querySelectorAll(".product_detail_block .item_row");
        if (!rows.length) return;

        const columns = rows[0].querySelectorAll(".item_column");
        const slideCount = columns.length - 1; 
        let current = 0; 

        const dotsWrap = document.querySelector(".slider_dots");

        for (let i = 0; i < slideCount; i++) {
            const dot = document.createElement("div");
            dot.className = "slider_dot";
            if (i === 0) dot.classList.add("active");
            dot.dataset.index = i;
            dotsWrap.appendChild(dot);
        }

        const dots = document.querySelectorAll(".slider_dot");

        function updateSlides(index) {
            rows.forEach(row => {
            const cols = row.querySelectorAll(".item_column");
            cols.forEach((col, i) => {
                if (i === index + 1) {
                col.classList.add("active_item");
                } else if (i !== 0) {
                col.classList.remove("active_item");
                }
            });
            });

            dots.forEach(d => d.classList.remove("active"));
            dots[index].classList.add("active");
        }

        document.querySelector(".next").addEventListener("click", () => {
            current = (current + 1) % slideCount;
            updateSlides(current);
        });

        document.querySelector(".prev").addEventListener("click", () => {
            current = (current - 1 + slideCount) % slideCount;
            updateSlides(current);
        });

        dots.forEach(dot => {
            dot.addEventListener("click", () => {
            current = parseInt(dot.dataset.index);
            updateSlides(current);
            });
        });

        updateSlides(0);
    });